import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { Suspense, type ReactNode } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { HelmetProvider } from 'react-helmet-async';

import { MainErrorFallback } from '@/components/errors/main-error-fallback';
import { FullScreenLoader } from '@/components/loaders/full-screen-loader';
import { Notifications } from '@/components/ui/notifications';
import { env } from '@/config/env';
import { ActionCableProvider } from '@/lib/action-cable';
import { queryClient } from '@/lib/react-query';

type AppProviderProps = {
  children: ReactNode;
};

export const AppProvider = ({ children }: AppProviderProps) => {
  const websocketUrl = env.WEBSOCKET_URL;

  return (
    <Suspense fallback={<FullScreenLoader />}>
      <ErrorBoundary FallbackComponent={MainErrorFallback}>
        <HelmetProvider>
          <QueryClientProvider client={queryClient}>
            {import.meta.env.DEV && <ReactQueryDevtools />}
            <Notifications />

            <ActionCableProvider url={websocketUrl}>
              {children}
            </ActionCableProvider>
          </QueryClientProvider>
        </HelmetProvider>
      </ErrorBoundary>
    </Suspense>
  );
};
